import { AMP_VERTICALS, YILU_FEATURE } from 'applicationConstants';

import { yiluEnv } from 'utils';

import {
  useEnterprisePartnerConfigurationContext,
  useIsFeatureFlagEnabled,
  useIsVerticalEnabled,
  useUserProfileContext,
} from 'context';

import routes from './routes';

export const useTIRouterProps = (initialPath?: string) => {
  // start tracking
  const {
    userProfileState: {
      data: {
        consent: { statistics },
      },
    },
  } = useUserProfileContext();
  const {
    enterprisePartnerConfigurationState: { enabledVerticals },
  } = useEnterprisePartnerConfigurationContext();
  const isShowTrackingConsentEnabled = useIsFeatureFlagEnabled(YILU_FEATURE.SHOW_TRACKING_CONSENT);
  const startTracking = isShowTrackingConsentEnabled && statistics;
  const yiluEnvVariables = yiluEnv.getVariables();

  // default path
  const verticalToStartingRouteMap: Record<AMP_VERTICALS, string> = {
    [AMP_VERTICALS.PARKING]: routes.PARKING_SEARCH,
    [AMP_VERTICALS.LOUNGES]: routes.LOUNGES_SEARCH,
    [AMP_VERTICALS.CAR_RENTAL]: routes.MEILI_CAR_RENTAL,
    [AMP_VERTICALS.EURAIL]: routes.EURAIL_SEARCH,
  };
  const firstFoundEnabledVertical = Object.keys(enabledVerticals || {})[0] as AMP_VERTICALS;
  const defaultPath =
    initialPath ||
    (firstFoundEnabledVertical && verticalToStartingRouteMap[firstFoundEnabledVertical]) ||
    routes.BASE;

  // enabled products
  const isMeiliEnabled = Boolean(yiluEnvVariables.YILU_MEILI_PTID);
  const isEmbeddedEnabled = yiluEnvVariables.YILU_EMBEDDED_TI === 'true';
  const isLandingPageEnabled = yiluEnvVariables.YILU_LANDING_PAGE_ENABLED === 'true';
  const isMeiliManagePageEnabled = yiluEnvVariables.YILU_MEILI_MANAGE_ENABLED === 'true';

  const hasEnabledLoungeServiceProviders = useIsVerticalEnabled(AMP_VERTICALS.LOUNGES);
  const hasEnabledParkingServiceProviders = useIsVerticalEnabled(AMP_VERTICALS.PARKING);
  const hasEnabledEurail = useIsVerticalEnabled(AMP_VERTICALS.EURAIL);

  return {
    defaultPath,
    startTracking,
    hasEnabledLoungeServiceProviders,
    hasEnabledParkingServiceProviders,
    isMeiliEnabled,
    isEmbeddedEnabled,
    isLandingPageEnabled,
    isMeiliManagePageEnabled,
    hasEnabledEurail,
  };
};
